module.exports = __webpack_public_path__ + "img/Green_winged_Teal.5ca853d3.png";